export default __webpack_public_path__ + "static/zon-the-go1-1f5297f23c59de241b14c7c3786b5f00.png";